import {PaletteOptions} from '@mui/material';

import {Colors} from '@constants/colors.constants';

const palette: PaletteOptions = {
  primary: {
    main: Colors.primary,
  },
  info: {
    main: Colors.info,
  },
  warning: {
    main: Colors.warning,
  },
  success: {
    main: Colors.success,
  },
  error: {
    main: Colors.error,
  },
  text: {
    primary: Colors.text,
    secondary: Colors.textWithOpacity,
  },
  background: {
    default: Colors.background,
    paper: Colors.white,
  },
  divider: Colors.textWithOpacity,
};

export default palette;
